<script setup lang="ts">
import type { IAiChatDeposit } from './types'
import { localizedField, formatUpToPeriodMonths, formatRate } from '../utils'

const props = defineProps<{ item: IAiChatDeposit }>()
const { t, locale } = useI18n()

const title = computed(() => localizedField(props.item.title, locale.value))
const bank = computed(() => localizedField(props.item.bank, locale.value))
const rate = computed(() =>
  props.item.rate != null ? `${t('common.up_to')} ${formatRate(props.item.rate)}` : null
)
const period = computed(() => formatUpToPeriodMonths(props.item.period_months, t))
</script>

<template>
  <NuxtLink :to="item.url" class="AiCard group">
    <div class="min-w-0">
      <div class="truncate text-sm font-semibold text-gray-900 group-hover:text-blue-600">
        {{ title }}
      </div>
      <div class="text-xs text-gray-500">{{ bank }}</div>
    </div>
    <div class="mt-2 grid grid-cols-3 gap-x-3 gap-y-2">
      <div v-if="rate">
        <div class="SecondaryTextHeadings">{{ $t('common.annual_rate') }}</div>
        <div class="text-sm font-semibold">{{ rate }}</div>
      </div>
      <div v-if="period">
        <div class="SecondaryTextHeadings">{{ $t('entity.deposit.item.deposit_term') }}</div>
        <div class="text-sm font-semibold">{{ period }}</div>
      </div>
      <div v-if="item.currency">
        <div class="SecondaryTextHeadings">{{ $t('common.currency') }}</div>
        <div class="text-sm font-semibold">{{ item.currency }}</div>
      </div>
    </div>
  </NuxtLink>
</template>
